import FirebaseLogin from './components/FirebaseLogin'
import SpeechToTextRecognition from './Speech'
import './App.css'
import { Route, Routes } from 'react-router'
import PrivateRoute from './components/PrivateRoute';
import SummaryPage from './components/SummaryPage';



function LandingPage() {
  return (
    <>
      <div class="inline-flex flex-col items-center justify-center min-h-screen w-full bg-[radial-gradient(circle,_rgba(0,0,0,0.11)_1px,_transparent_1px)] bg-[length:40px_40px]">
        <div class="m-12 text-5xl font-medium font-roboto py-4 text-gray-600">AI summarization for meetups</div>
        <div class="py-2 px-12 inline-flex items-center gap-x-2 text-lg font-medium font-roboto rounded-xl border border-transparent bg-blue-600 text-white hover:bg-blue-700 focus:outline-hidden focus:bg-blue-700 disabled:opacity-50 disabled:pointer-events-none">
          Start
        </div>
      </div>
    </>
  )
}

function App() {

  // if (loading) {
  //   return (
  //     <div className="loading-container">
  //       <div className="loading-spinner"></div>
  //       <p>Loading...</p>
  //     </div>
  //   );
  // }

  return (
    <>
      {/* <LandingPage /> */}
      <Routes>
        <Route index element={<SpeechToTextRecognition />} />
        <Route path="/saved/:id" element={<PrivateRoute><SummaryPage/></PrivateRoute>} />
      </Routes>
    </>
  )
}

export default App

// TODO:
// Toast message on save
// 